import { render, staticRenderFns } from "./HelpNavBar.vue?vue&type=template&id=68c04667&scoped=true&"
import script from "./HelpNavBar.vue?vue&type=script&lang=js&"
export * from "./HelpNavBar.vue?vue&type=script&lang=js&"
import style0 from "./HelpNavBar.vue?vue&type=style&index=0&id=68c04667&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c04667",
  null
  
)

export default component.exports